<form [formGroup]="rxForm">
    <ng-container *ngIf="!drugsControl.controls.length; else drugListTemplate">
        <nz-empty [nzNotFoundContent]="'No Drugs'"> </nz-empty>
    </ng-container>

    <ng-template #drugListTemplate>
        <div nz-row class="drug-list">
            <div
                formArrayName="drugs"
                *ngFor="let dControl of drugsControl.controls; let i = index"
                class="drug"
            >
                <ng-container
                    *ngTemplateOutlet="
                        drugItemTemplate;
                        context: { item: drugsControl.at(i), index: i }
                    "
                ></ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #drugItemTemplate let-item="item" let-i="index">
        <div [formGroup]="item">
            <div nz-row>
                <h5 style="flex-grow: 1">{{ item.get('drugName').value }}</h5>
                <div nz-col>
                    <nz-form-item>
                        <nz-form-label nzFor="mitte"> Mitte </nz-form-label>
                        <nz-form-control nzErrorTip="Required">
                            <nz-input-group
                                [nzSuffix]="item.get('mitteType').value || ''"
                            >
                                <input
                                    [attr.data-cy]="'cy-input-rx-mitte' + i"
                                    nz-input
                                    placeholder="Mitte"
                                    formControlName="mitte"
                                    min="0"
                                    name="mitte"
                                    type="number"
                                />
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzSpan="1"></div>
                <div nz-col>
                    <nz-form-item>
                        <nz-form-label nzFor="refills"> Refills </nz-form-label>
                        <nz-form-control nzErrorTip="Required">
                            <input
                                [attr.data-cy]="'cy-input-rx-refills' + i"
                                nz-input
                                placeholder="Refills"
                                formControlName="refills"
                                min="0"
                                name="refills"
                                type="number"
                            />
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            <nz-form-item>
                <nz-form-control nzErrorTip="Required">
                    <textarea
                        [attr.data-cy]="'cy-textarea-rx-sig' + i"
                        nz-input
                        placeholder="Sig"
                        formControlName="notes"
                        name="drugNotes"
                        type="string"
                    ></textarea>
                </nz-form-control>
            </nz-form-item>

            <i
                [attr.data-cy]="'cy-i-remove-drug' + i"
                class="remove-drug fas fa-trash"
                (click)="removeDrug(i)"
            ></i>
        </div>
    </ng-template>
    <div nz-row class="select-drug-row">
        <div nz-col nzSpan="24">
            <portals-emr-drug-selector
                [addButton]="true"
                (drugSelected)="onDrugSelected($event)"
                (drugAdded)="onDrugAdded($event)"
            >
            </portals-emr-drug-selector>
        </div>
    </div>

    <nz-divider nzText="RX Note" nzOrientation="left"></nz-divider>
    <div nz-row>
        <textarea
            class="notes"
            placeholder="Doctors Notes..."
            formControlName="notes"
            name="notes"
        ></textarea>
    </div>
    <nz-divider
        *ngIf="isPharmacy"
        nzText="Authorization"
        nzOrientation="left"
    ></nz-divider>
    <div
        *ngIf="isPharmacy"
        style="
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 20px;
            border-radius: 5px;
        "
    >
        <input
            nz-input
            placeholder="Authorized By"
            formControlName="authorizedBy"
            type="text"
        />
    </div>

    <div style="margin-bottom: 3rem">
        <nz-divider nzText="Extras" nzOrientation="left"></nz-divider>
        <lite-json-editor formControlName="extras"></lite-json-editor>
    </div>

    <div style="margin-bottom: 3rem">
        <nz-divider nzText="Metadata" nzOrientation="left"></nz-divider>
        <lite-json-editor
            formControlName="meta"
            [withoutEdit]="true"
        ></lite-json-editor>
    </div>
</form>
<div
    nz-row
    nzType="flex"
    nzJustify="space-around"
    [class]="
        rx
            ? 'button-group-update actions-group'
            : 'button-group-create actions-group'
    "
>
    <button
        data-cy="cy-button-rx-detail-submit"
        nz-button
        nzType="primary"
        nzShape="round"
        (click)="saveRx()"
        [nzLoading]="isSaving || isUpdating"
    >
        <i
            *ngIf="!isSaving && !isUpdating"
            class="fas fa-prescription-bottle-alt"
        ></i
        >&nbsp;{{ rx ? 'Save RX' : 'Create RX' }}
    </button>
    <button
        data-cy="cy-button-rx-detail-cancel"
        nz-button
        nzType="primary"
        nzShape="round"
        (click)="close()"
        [disabled]="isSaving || isUpdating"
    >
        <i *ngIf="!isSaving && !isUpdating" class="fas fa-times-circle"></i
        >&nbsp;Cancel
    </button>
    <button
        data-cy="cy-button-rx-detail-void"
        *ngIf="mode === 'edit'"
        nz-button
        nzType="primary"
        nzShape="round"
        (click)="voidRx()"
        [disabled]="!!rx.voidedAt || !!isUpdating"
        nzDanger
    >
        <i *ngIf="!isUpdating" class="fas fa-file-excel"></i>&nbsp;{{
            rx.voidedAt ? 'Voided' : 'Void RX'
        }}
    </button>
</div>
